// extracted by mini-css-extract-plugin
export default {"button":"pr-z","reviewSort":"qr-z"};